import styled from 'styled-components';
import { ArrowBack, Cake } from '@material-ui/icons';

export const TitleWrapper = styled.div`
  font-family: 'Poppins', sans-serif;
  line-height: 18px;
`;

export const TitleMain = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: white;

  strong {
    font-weight: 600;
  }
`;

export const TitleSubtitle = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2px;
`;

export const BackIcon = styled(ArrowBack)`
  color: white !important;
  font-size: 22px !important;
`;

export const CakeIcon = styled(Cake)`
  float: right;
  color: #777777;
`;

export const HEADER_STYLE = {
  background: 'rgb(0, 75, 196)',
  borderBottom: 'none',
  color: 'white',
  padding: '4px 20px 4px 8px',
};

export const DRAWER_STYLE = {
  overflow: 'auto',
  paddingLeft: '0',
  paddingRight: '0',
};
